import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import ImportContactsOutlinedIcon from "@mui/icons-material/ImportContactsOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import QuickreplyIcon from "@mui/icons-material/Quickreply";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CalendarMonthOutlined from "@mui/icons-material/CalendarMonthOutlined";
import FormatListNumbered from "@mui/icons-material/FormatListNumbered";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { SvgIconProps } from "@mui/material";
import React from "react";

/* eslint-disable no-unused-vars */
export const enum SectionType {
  Front = "0",
  CurrentTopics = "1",
  Documents = "2",
  Events = "3",
  Tasks = "4",
  UserRecords = "5",
  CompanyGroups = "6",
  Companies = "7",
  UserGroups = "8",
  Users = "9",
  Log = "10",
  ExternalSystems = "11",
  InstantMessages = "12",
  WhistleBlow = "13",
  CalendarTasks = "14",
  Reports = "15",
  Risks = "16",
}
/* eslint-enable no-unused-vars */

export const SectionIcon = ({
    type,
    ...props
}: SvgIconProps & { type: SectionType }) =>
    <>
        {type === SectionType.Front && <GridViewOutlinedIcon {...props} />}
        {type === SectionType.CurrentTopics && <MessageOutlinedIcon {...props} />}
        {type === SectionType.Documents && <InsertDriveFileOutlinedIcon {...props} />}
        {type === SectionType.Events && <ErrorOutlineIcon {...props} />}
        {type === SectionType.Tasks && <ChecklistIcon {...props} />}
        {type === SectionType.UserRecords && <ImportContactsOutlinedIcon {...props} />}
        {type === SectionType.CompanyGroups && <BusinessOutlinedIcon {...props} />}
        {type === SectionType.Companies && <BusinessOutlinedIcon {...props} />}
        {type === SectionType.UserGroups && <PeopleAltOutlinedIcon {...props} />}
        {type === SectionType.Users && <PersonOutlineOutlinedIcon {...props} />}
        {type === SectionType.Log && <ListAltOutlinedIcon {...props} />}
        {type === SectionType.ExternalSystems && <MeetingRoomIcon {...props} />}
        {type === SectionType.InstantMessages && <QuickreplyIcon {...props} />}
        {type === SectionType.WhistleBlow && <VisibilityOutlinedIcon {...props} />}
        {type === SectionType.CalendarTasks && <CalendarMonthOutlined {...props} />}
        {type === SectionType.Reports && <FormatListNumbered {...props} />}
        {type === SectionType.Risks && <WarningAmberIcon {...props} />}
    </>
;
